export default __webpack_public_path__ + "static/media/tour-3.dab357b9.png";